module.exports = __webpack_public_path__ + "static/img/moreproduct1.05cd8ba3.png";